import {
  ApplicationConfig,
  LOCALE_ID,
  importProvidersFrom,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { provideNgxMask } from 'ngx-mask';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import {
  provideRecaptchaV3,
  provideRecaptchaOptions,
  provideFeatureFlag,
} from 'src/config';
import { RecaptchaProviderModule } from './shared/providers';
import {
  apiInterceptor,
  authInterceptor,
  traceInterceptor,
} from './data/interceptors';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideRecaptchaV3(),
    provideHttpClient(
      withInterceptors([apiInterceptor, authInterceptor, traceInterceptor]),
    ),
    provideToastr(),
    provideNgxMask(),
    provideRecaptchaOptions(),
    importProvidersFrom(RecaptchaProviderModule),
    provideFeatureFlag(),
    { provide: LOCALE_ID, useValue: 'es' },
  ],
};
